import React, { useRef, useState } from 'react';
import { SlInput, SlIcon } from '@shoelace-style/shoelace/dist/react';
import SpecialAdReport from '../reports/SpecialAdReport';
import { debounce } from '../../utils/Debounce';

function VendorSpecialAdReport() {
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [search, setSearch] = useState('');

    const debouncedSearchRef = useRef(
        debounce((value) => setSearch(value), 500),
    );

    const handleDateChange = (e) => {
        const value = e.target.value;
        if (value) setSelectedDate(new Date(value));
    };

    const dateInputValue = selectedDate.toISOString().slice(0, 10);

    return (
        <div className="p-3">
            <div className="flex gap-3 items-center mb-3">
                <SlInput
                    size="small"
                    type="date"
                    value={dateInputValue}
                    onSlChange={handleDateChange}
                />
                <SlInput
                    size="small"
                    placeholder="Search campaigns.."
                    onSlInput={(e) => debouncedSearchRef.current(e.target.value)}
                >
                    <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
                </SlInput>
            </div>
            <SpecialAdReport dateFilter={selectedDate} search={search} />
        </div>
    );
}

export default VendorSpecialAdReport;
